import React from 'react';

import PsychToolPageBase, { PsychToolPageProps } from './PsychToolPageBase';

const PsychPreferencePage: React.FC<PsychToolPageProps> = ({ onBack, onRequireLogin }) => (
  <PsychToolPageBase onBack={onBack} onRequireLogin={onRequireLogin} testId='preference' />
);

export default PsychPreferencePage;
